'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);


var _HeaderPhones = require('../HeaderPhones/HeaderPhones');var _HeaderPhones2 = _interopRequireDefault(_HeaderPhones);


var _AboutStaff = require('./AboutStaff.scss');var styles = _interopRequireWildcard(_AboutStaff);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Components
// Modules
var AboutStaff = function AboutStaff(props) {
  var renderImage = function renderImage() {return (
      _react2.default.createElement('div', { className: styles.companyLogo },
        _react2.default.createElement('div', { className: styles.logoImg },
          _react2.default.createElement('img', { src: props.staffData ? props.staffData.profile_img : '', alt: '' }))));};




  var renderName = function renderName() {return (
      _react2.default.createElement('div', { className: styles.infoBlock_title },
        _react2.default.createElement('h1', null, props.staffData.name)));};



  var renderCompanyLogo = function renderCompanyLogo() {return (
      _react2.default.createElement('div', { className: styles.infoBlock_title },
        _react2.default.createElement('div', null,
          _react2.default.createElement('img', { src: props.staffData ? props.staffData.logo : '', alt: '' }),
          _react2.default.createElement('p', null, props.staffData.company_name[props.locale] || props.staffData.company_name.he))));};




  var renderPhones = function renderPhones() {return (
      _react2.default.createElement(_HeaderPhones2.default, {
        translate: props.translate,
        phoneNumber: props.staffData.phone_number,
        locale: props.locale,
        isMobile: props.isMobile }));};



  return (
    _react2.default.createElement('div', { className: styles.wrapper },
      renderImage(),
      _react2.default.createElement('div', { className: styles.infoBlock },
        props.staffData && props.staffData.name &&
        renderName(),

        props.staffData.logo && renderCompanyLogo(),
        props.staffData && props.staffData.phone_number && renderPhones())));



}; // styles

AboutStaff.propTypes = {
  isMobile: _propTypes2.default.bool,
  onShowPhones: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  staffData: _propTypes2.default.object,
  companyLogo: _propTypes2.default.string,
  name: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  is_association_member: _propTypes2.default.bool,
  phoneNumber: _propTypes2.default.string,
  isNameAtDefaultLang: _propTypes2.default.bool,
  isShowPhone: _propTypes2.default.bool };exports.default =


AboutStaff;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorUser/AboutStaff/AboutStaff.js
// module id = 2863
// module chunks = 0